import rest from '@feathersjs/rest-client'
import feathers from '@feathersjs/feathers'
import auth from '@feathersjs/authentication-client'
import axios from 'axios'
import { type Router } from 'vue-router'
import { getCurrentInstance } from 'vue'

export type ManagerApi = feathers.Application & {
  user?: {
    _id: string
    role: string
  }
  accessToken?: string
}

export default function getApi(url: string, router: Router): ManagerApi {
  const app = feathers()

  // Need hook to handle jwt expiry
  app.hooks({
    error(context) {
      if (context.error && context.error.code === 401) {
        void router.push('/')
      }
      console.log(context)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;(context as any).message = 'Not logged in.'
      return context
    },
  })

  // Connect to a different URL
  const restClient = rest(url).axios(axios)
  // Configure an AJAX library (see below) with that client
  app.configure(restClient)
  app.configure(auth())

  return app
}

/**
 * Used to make vue-toast-notification work in composition API in Vue 2.7.
 * Can be removed in Vue 3 since it will exist in vue-toast-notification then.
 */
export function useApi(): ManagerApi {
  const v = getCurrentInstance()
  if (!v?.proxy) {
    throw new Error('not in a vue instance')
  }
  return v.proxy.$api
}

// TODO: this is bad practice, use provide/inject pattern instead
declare module 'vue' {
  interface ComponentCustomProperties {
    $api: ManagerApi
  }
}
